import React from 'react';

import Checkbox from '.';
import { Label, TextContent } from './styled';


function LabelCheckboxComponent({
  checkboxPosition = 'left',
  iconSize = '24px',
  style,
  disabled, children,
  ...props
}) {
  return (
    <Label style={style} isDisabled={disabled}>
      {checkboxPosition === 'left' && (
        <Checkbox
          iconSize={iconSize}
          disabled={disabled}
          {...props}
        />
      )}

      <TextContent
        checkboxPosition={checkboxPosition}
        isDisabled={disabled}
      >
        {children}
      </TextContent>

      {checkboxPosition === 'right' && (
        <Checkbox
          iconSize={iconSize}
          disabled={disabled}
          {...props}
        />
      )}
    </Label>
  );
}

export default LabelCheckboxComponent;
